<template>
    <div :class="['user-image-wrapper', 'rounded-circle', { 'has-initials': !hasImage, 'has-image': hasImage }]" :style="divStyle">
        <div v-if='hasImage' :style='imgStyle'></div>
        <span v-else>
      {{ organization.name ? organization.name.substring(0, 1) : ''}}
    </span>
    </div>
</template>

<script>
    export default {
        props: {
            organization: {
                type: Object,
                required: true
            },
            propStyle: {
                type: Object,
                default: Object
            }
        },
        computed: {
            divStyle() {
                return Object.assign({}, {
                    width: '45px',
                    height: '45px',
                    'line-height': '45px',
                }, this.$props.propStyle)
            },
            imgStyle() {
                return Object.assign({}, this.divStyle , {
                    'background-image': 'url(' + this.previewUrl(this.$props.organization.logo_url) + ')',
                    'background-repeat': 'no-repeat',
                    'background-size': 'contain',
                    'background-position': '50% 50%'
                })
            },
            hasImage() {
                return !!this.$props.organization.logo_url
            }
        }
    }
</script>
